export const environment = {
  production: true,
  localDevUrl: 'http://localhost/',
  cognito: {
    user_pool_id: 'us-east-1_ZPPSiSJNu',
    client_id: '6qhjddn8tos35e59hk5gla3o4p',
    prisma_url: 'https://we8hti241h.execute-api.us-east-1.amazonaws.com/prod',
    region: 'us-east-1',
    cookie_domain: '.sytex.io'
  },
  i18n: {
    cookie_name: 'sytex_language'
  },
  name: 'production',
  sso: {
    cognito_identity_provider_url:
      'https://sytex.auth.us-east-1.amazoncognito.com/oauth2/authorize?identity_provider=USERINPUT&redirect_uri=https://auth.sytex.io/callback&response_type=CODE&client_id=USERCLIENTID&scope=email openid phone profile&prompt=login',
    cognito_callback_url: 'https://auth.sytex.io/callback',
    cognito_token_endpoint_url: 'https://sytex.auth.us-east-1.amazoncognito.com/oauth2/token',
    sytex_url: 'https://app.sytex.io/'
  }
};